import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

// Email chips: pick from suggestions or type any address (Enter / comma adds it).
export function EmailChips({ value, onChange, suggestions = [], placeholder, testid }) {
  const [text, setText] = useState("");
  const add = (e) => {
    const v = (e || text).trim().toLowerCase().replace(/[,;]$/, "");
    if (v && !value.includes(v)) onChange([...value, v]);
    setText("");
  };
  const left = suggestions.filter((s) => !value.includes(s.email));
  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1 rounded border border-slate-200 bg-white p-1.5 min-h-9">
        {value.map((v) => (
          <span key={v} className="inline-flex items-center gap-1 rounded bg-sky-50 border border-sky-200 px-2 py-0.5 text-xs text-sky-900" data-testid={`${testid}-chip`}>
            {v}<button type="button" onClick={() => onChange(value.filter((x) => x !== v))} aria-label={`Remove ${v}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
        <Input value={text} onChange={(e) => setText(e.target.value)} onBlur={() => text && add()} placeholder={placeholder}
          onKeyDown={(e) => { if (["Enter", ",", ";"].includes(e.key)) { e.preventDefault(); add(); } }}
          className="h-7 flex-1 min-w-[12rem] border-0 shadow-none focus-visible:ring-0 px-1" data-testid={`${testid}-input`} />
      </div>
      {left.length > 0 && <div className="mt-1 flex flex-wrap gap-1">
        {left.slice(0, 12).map((s) => <button key={s.email} type="button" onClick={() => add(s.email)} className="rounded-full border border-slate-200 px-2 py-0.5 text-[11px] text-slate-600 hover:bg-slate-50" data-testid={`${testid}-suggest`}>+ {s.name ? `${s.name} <${s.email}>` : s.email}</button>)}
      </div>}
    </div>
  );
}
